import { render, staticRenderFns } from "./SignPage.vue?vue&type=template&id=c0f07436&scoped=true&"
import script from "./SignPage.vue?vue&type=script&lang=js&"
export * from "./SignPage.vue?vue&type=script&lang=js&"
import style0 from "./SignPage.vue?vue&type=style&index=0&id=c0f07436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f07436",
  null
  
)

export default component.exports